import React from 'react';
export interface EditViewInPlaceContext {
    set(edit: boolean);
    editing: boolean;
}
export const editViewInPlaceContext = React.createContext<EditViewInPlaceContext>({
    set: (edit) => {},
    editing: false,
});
